import { TaskExecutionsCreationSchemaType, TaskIdType } from "../../../../schemas/task.schemas";


export function getTaskExecutionCreateFormDefaultState(taskId: TaskIdType): TaskExecutionsCreationSchemaType {
    return {
        taskId,
        entities: []
    };
}